// extracted by mini-css-extract-plugin
export default {"fallbackMessage":"fallback-component_fallbackMessage__Oiv3c"};